export default {
    showVariationsModal: {
        copy: 'Kopia',
        contentVariation: 'Innehållsvariation',
        chosenContent: 'Valt innehåll',
        chosenContentPlaceholder: 'Vänligen ange',
        continue: 'Fortsätt',
        generateNewContent: 'Generera nytt innehåll',
        type: 'Typ:',
        contentTitle: 'Titel:',
        descriptionLabel: 'Beskrivning:',
        keywordsLabel: 'Nyckelord:',
        writingTone: 'Skrivton:',
        context: 'Sammanhang:',
        cancel: 'Avbryt',
        emailBuilderTooltip: 'Custom values for sender and recipient is added in the content.',
    },
};
